import * as types from "../actions/types/index";

const INITIAL_STATE = {
    wallet_balance: parseFloat("0.00").toFixed(2),
    user_details: null,
    isVisible: false
};
export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.MONEYBLOX_WALLET_BALANCE:
            return {
                ...state,
                wallet_balance: action.wallet_balance
            };
        case types.MONEYBLOX_WALLET_USER_DETAILS:
            return {
                ...state,
                user_details: action.user_details
            };
        case types.MONEYBLOX_WALLET_MODAL_SHOW:
            return {
                ...state,
                isVisible: action.isVisible
            };
        case types.MONEYBLOX_WALLET_MODAL_HIDE:
            return {
                ...state,
                isVisible: action.isVisible
            };
        default:
            return {
                ...state
            }
    }
}